import styled from '@emotion/styled'

export const StyleWrapper = styled.div`
  height: 100vh;
  overflow-y: auto;
`

export const StyleBackDropWrapper = styled.div`
  position: fixed;
  z-index: 111;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const StyleModalWrapper = styled.div`
  background: white;
  width: 50%;
  padding: 20px 15px;
  border-radius: 12px;
`
export const StyleTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: ${(props: any) => props.theme.colors.black};
  text-align: center;
`

export const StyleDescription = styled.p`
  font-size: 14px;
  color: ${(props: any) => props.theme.colors.grey300};
  text-align: center;
  margin-top: 10px;
`
